export default "__VITE_ASSET__Bv0i0MsH__"